module.exports = __webpack_public_path__ + "img/jobs-bg.41fe697e.jpg";